import { render } from "./HoriontalCard3.vue?vue&type=template&id=245afd36&ts=true"
import script from "./HoriontalCard3.vue?vue&type=script&lang=ts"
export * from "./HoriontalCard3.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__